/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('RelationMailGroupController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		RelationMailGroupFactory,
		FindAllRelationMailGroupsByQueryParamsFactory,
		AutocompleteRelationsByQueryParamsFactory,
		NoPagingRelationMailGroupFactory,
		NoPagingRelationFactory,
		NoPagingMailGroupFactory
	) {
		$scope.relationMailGroupList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeRelationMailGroup)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeRelationMailGroup);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeRelationMailGroup = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('relationmailgroup.list.new');
		};

		$scope.goToEditState = function(relationMailGroup) {
			// this overview is NOT mapped, it is the main overview
			$state.go('relationmailgroup.list.edit', { relationMailGroupId: relationMailGroup.id });
		};

		$scope.getRelationMailGroupList = function() {
			FindAllRelationMailGroupsByQueryParamsFactory.query(
				{
					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.relationMailGroupList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getRelationMailGroupList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedRelationMailGroupId = id;
			$('#deleteRelationMailGroupConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			RelationMailGroupFactory.delete(
				{ id: $scope.selectedRelationMailGroupId },
				function() {
					$scope.loadAll();
					$('#deleteRelationMailGroupConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteRelationMailGroupConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});
